import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import mPrompto from "../../images/home/client/m-Prompto.svg";
import cmp from "../../images/home/client/cmp.png";
import Toyota from "../../images/home/client/Toyota.svg";
import cio360 from '../../images/home/client/cio360.svg';
import kesari from "../../images/home/client/kesari.svg";
// import celebal from '../../images/home/client/celebal.png';
import Finovia from "../../images/home/client/finovia.svg";
import cvp from '../../images/home/client/cvp.png';
import nbc from "../../images/home/client/nbc.svg";
import lessmeeting from "../../images/home/client/lessmeeting.png";
import cybersiara from "../../images/home/client/cybersiara.svg";
import walmart from "../../images/home/client/walmart.svg";
import GifTap from "../../images/home/client/GifTap.png";
import otoai from "../../images/home/client/otoai.svg";

const ClientLogo = {
  nav: false,
  loop: true,
  margin: 70,
  dots: false,
  autoplay: true,
  autoplaySpeed: 2200,
  autoplayTimeout: 2200,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 1,
    },
    481: {
      items: 2,
    },
    576: {
      items: 3,
    },
    768: {
      items: 4,
    },
    992: {
      items: 5,
    },
  },
};

const partnerLogo = [
  {
    images: kesari,
  },
  {
    images: mPrompto,
  },
  {
    images: otoai,
  },
  {
    images: Finovia,
  },
  {
    images: cio360,
  },
  {
    images: cvp,
  },
  {
    images: Toyota,
  },
  {
    images: walmart,
  },
  {
    images: nbc,
  },
  {
    images: cmp,
  },
  {
    images: lessmeeting,
  },
  {
    images: cybersiara,
  },
  {
    images: GifTap,
  },
];

const Client = () => {
  return (
    <>
      <section className="clientSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading" data-aos="slide-right">
                <h3>
                  Notable Clients <span>We Have Served</span>
                </h3>
                <p>Our true value can be perceived by our customers!</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <OwlCarousel className="owl-carousel owl-theme" {...ClientLogo}>
                {partnerLogo.map((each, i) => (
                  <div className="item" data-aos="zoom-in" key={i}>
                    <img
                      src={each.images}
                      alt="Hire Dedicated Angular Developer"
                    />
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Client;
